<div class="container">
  <div class="grid-display">
    <div class="title">Drivers</div>
    <div class="driver-reference-grid-actions">
      <div class="search-container {{ loading ? 'loading' : '' }}">
        <search (searchTermChange)="changeSearch($event)" [(searchTerm)]="search"></search>
      </div>
      <button class="btn btn-primary add-job" (click)="onAddDriverClick()">{{ 'Add New Driver Reference' | translate }}</button>
    </div>
    <ag-grid-angular
      #driversGrid
      class="ag-theme-material drivers-grid"
      [animateRows]="true"
      [columnDefs]="columnDefs"
      [enableSorting]="true"
      [enableColResize]="true"
      [pagination]="true"
      [rowModelType]="rowModelType"
      [cacheBlockSize]="cacheBlockSize"
      [maxBlocksInCache]="maxBlocksInCache"
      [frameworkComponents]="frameworkComponents"
      [sideBar]="sideBar"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
      (gridReady)="onGridReady($event)"
      rowSelection="multiple"
      suppressBrowserResizeObserver="true"
    ></ag-grid-angular>
  </div>
</div>

